/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../../features/attachments/Attachments.generated.js';
import { OrganisationDetailsBox_ViewerOrganisationFragmentDoc } from '../../features/organisations/boxes/OrganisationDetailsBox.generated.js';
import { OrganisationPaymentInformationBox_ViewerOrganisationFragmentDoc } from '../../features/organisations/boxes/OrganisationPaymentInformationBox.generated.js';
import { OrganisationRegistrationDetailsBox_ViewerOrganisationFragmentDoc } from '../../features/organisations/boxes/OrganisationRegistrationDetailsBox.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationProfileQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrganisationProfileQuery = { viewer?: { __typename: 'Viewer', id: string, organisation: { __typename: 'ViewerOrganisation', id: string, title: string, organisationType: Types.OrganisationType, description: string, isCraftsmanOrganisation: boolean, email: any, website: string, categories: Array<string>, bankName: string, bankAccount: string, bankCode: string, fullLegalName: string, taxNumber: string, vatNumber: string, registrationNumber: string, registerCourt: string, registrationOffice: string, managingDirector: string, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, representive?: { __typename: 'User', id: string } | null, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, branchAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, pickupAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, profile?: { __typename: 'OrganisationProfile', id: string, slug: string } | null } } | null };


export const OrganisationProfileDocument = gql`
    query OrganisationProfile {
  viewer {
    id
    organisation {
      id
      title
      organisationType
      logo {
        ...AttachmentSnapshot
      }
      ...OrganisationDetailsBox_ViewerOrganisation
      ...OrganisationPaymentInformationBox_ViewerOrganisation
      ...OrganisationRegistrationDetailsBox_ViewerOrganisation
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}
${OrganisationDetailsBox_ViewerOrganisationFragmentDoc}
${OrganisationPaymentInformationBox_ViewerOrganisationFragmentDoc}
${OrganisationRegistrationDetailsBox_ViewerOrganisationFragmentDoc}`;

/**
 * __useOrganisationProfileQuery__
 *
 * To run a query within a React component, call `useOrganisationProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationProfileQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationProfileQuery, OrganisationProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationProfileQuery, OrganisationProfileQueryVariables>(OrganisationProfileDocument, options);
      }
export function useOrganisationProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationProfileQuery, OrganisationProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationProfileQuery, OrganisationProfileQueryVariables>(OrganisationProfileDocument, options);
        }
export function useOrganisationProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationProfileQuery, OrganisationProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationProfileQuery, OrganisationProfileQueryVariables>(OrganisationProfileDocument, options);
        }
export type OrganisationProfileQueryHookResult = ReturnType<typeof useOrganisationProfileQuery>;
export type OrganisationProfileLazyQueryHookResult = ReturnType<typeof useOrganisationProfileLazyQuery>;
export type OrganisationProfileSuspenseQueryHookResult = ReturnType<typeof useOrganisationProfileSuspenseQuery>;
export type OrganisationProfileQueryResult = Apollo.QueryResult<OrganisationProfileQuery, OrganisationProfileQueryVariables>;